module.exports = __webpack_public_path__ + "static/media/cf.a66ac030.svg";